import React, { useEffect, useState } from 'react';
import { Button, Container, Form, Row, Col } from "react-bootstrap";
import Select from "react-select";
import { useNavigate, useParams } from "react-router-dom";
import { BsArrowLeft } from "react-icons/bs";
import axios from 'axios';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { ring } from 'ldrs';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Cookies from 'js-cookie';
import {decryptData } from "../../../Auth/cryptage";




function UpdatePermission() {
    const [resources, setResources] = useState([]);
    const [permission, setPermission] = useState({ name: '', resources: [] });
    const [options, setOptions] = useState([]);
    const [selectedResources, setSelectedResources] = useState([]);
    const [loading, setLoading] = useState({ who: '', status: false });
    const { id } = useParams();
    const MySwal = withReactContent(Swal);
    const navigate = useNavigate();
    ring.register();
    // console.log()(loading);
    useEffect(() => {
        AOS.init({ duration: 1200 });
    }, []);
    useEffect(() => {
        document.title = "GecimmoIA - Modifier une permission";
    }, []);
    const getResources = async () => {
        try {
            setLoading({ 
                who: "resources", 
                status: true 
            });
            const token = decryptData(Cookies.get('access_token'));
            // console.log(token);
            const result = await axios.get('https://ai.api.gecimmo.xyz/AI-GECIMMO/public/api/admin/get-resources', {
                headers: { 
                    'X-Custom-Token': token 
                }
            });
            if(!result.data.resources){
                setResources([]);
            }else{
                setResources(result.data.resources);
                console.log(result.data.resources);
            }
            // console.log(result.data.resources);
        } catch (err) {
            MySwal.fire({ 
                title: "Error!", 
                text: err.message, 
                icon: "error" 
            });
        } finally {
            setLoading({ 
                who: "resources", 
                status: false 
            });
        }
    };

    const getPermission = async () => {
        try {
            setLoading({ 
                who: "permissions", 
                status: true 
            });
            const token = decryptData(Cookies.get('access_token'));
            const result = await axios.get(`https://ai.api.gecimmo.xyz/AI-GECIMMO/public/api/admin/permission/${id}`, {
                headers: { 'X-Custom-Token': token }
            });
            setPermission(result.data.permission[0]);
            setSelectedResources(result.data.permission[0].resources.map((resource) => ({
                value: resource.id,
                label: `${resource.name} (${resource.typeR})`
            })));
        } catch (err) {
            MySwal.fire({ 
                title: "Error!", 
                text: err.message, 
                icon: "error" 
            });
        } finally {
            setLoading({ 
                who:"permissions", 
                status: false 
            });
        }
    };
    
    useEffect(() => {
        const fetchData = async () => {
            await getPermission();
            await getResources();
        };
        fetchData();
    }, []);

    useEffect(() => {
        setOptions(resources.map((resource) => ({
            value: resource.id,
            label: `${resource.name} (${resource.typeR})`
        })));
    }, [resources]);

    const handleChange = (e) => {
        setPermission({ ...permission, name: e.target.value });
    };

    const handleSelectChange = (selectedOptions) => {
        setSelectedResources(selectedOptions);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const token = decryptData(Cookies.get('access_token'));
            const formData = new FormData(e.target);
            const permissionName = formData.get('permission_name');
            const selectedResourcesIds = formData.getAll('resources');
            setLoading({ who: "submit", status: true });
            await axios.put(`https://ai.api.gecimmo.xyz/AI-GECIMMO/public/api/admin/permission/${id}`, {
                name: permissionName,
                resources: selectedResourcesIds
            }, {
                headers: { 
                    'X-Custom-Token': token 
                }
            });

            MySwal.fire({ 
                title: "Success!", 
                text: "Permission updated successfully", 
                icon: "success" 
            });
            navigate(-1);
        } catch (err) {
            MySwal.fire({ 
                title: "Error!",
                text: err.message, 
                icon: "error" });
        } finally {
            setLoading({ 
                who: "submit", 
                status: false 
            });
        }
    };

    const back = () => {
        navigate(-1);
    };

    return (
        <Container fluid className="d-flex align-items-center justify-content-center">
            {
                loading.status && loading.who === "permissions" ?  (
                    <l-ring
                        size="30"
                        stroke="3"
                        bg-opacity="0"
                        speed="2"
                        color="black"
                    />
                ) :(
                    <Col data-aos="fade-up" className="justify-content-center">
                        <Row className="justify-content-center w-100 mb-4">
                            <Col xs={12} md={8} lg={6}>
                                <div className="form-container">
                                    <h3 className="createRoleTitle text-center mb-5">Créer une Permission</h3>
                                    <Form onSubmit={handleSubmit}>
                                        <Form.Group className="mb-4 w-100" controlId="permission_name">
                                            <Form.Label>Nom de permission</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="permission_name"
                                                size="lg"
                                                value={permission.name}
                                                onChange={handleChange}
                                                required
                                            />
                                        </Form.Group>
                                        <Form.Group className="mb-4 w-100 text-center" controlId="resources">
                                            <Form.Label>Les ressources</Form.Label>
                                            <Select
                                                name="resources"
                                                options={options}
                                                isMulti
                                                value={selectedResources}
                                                onChange={handleSelectChange}
                                                placeholder={loading.status && loading.who === "resources" ? (
                                                    <l-ring
                                                        size="30"
                                                        stroke="3"
                                                        bg-opacity="0"
                                                        speed="2"
                                                        color="black"
                                                    />
                                                ) : "Choisissez les ressources"}
                                                className="basic-multi-select"
                                                classNamePrefix="select"
                                            />
                                        </Form.Group>
                                        <Button
                                            className="mb-4 w-100 gradient-custom-4"
                                            size="lg"
                                            type="submit"
                                        >
                                            {loading.status && loading.who === "submit" ? (
                                                <l-ring
                                                size="30"
                                                stroke="3"
                                                bg-opacity="0"
                                                speed="2"
                                                color="white"
                                            />
                                            ) : 'Modifier'}
                                        </Button>
                                        <Button className="backbtn btn-danger mb-4 w-100" onClick={back} size="lg">
                                            <BsArrowLeft className="btnbackIcon" />
                                            Back
                                        </Button>
                                    </Form>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                )
            }
        </Container>
    );
}

export default UpdatePermission;
